import React from "react";
import styled, { css, keyframes } from "styled-components";
import { ReactComponent as BackSvg } from "./assets/back.svg";
import useSound from "use-sound";
import goBack from "./audio/goBack.mp3";

export const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  & > div ::-webkit-scrollbar {
    display: none;
  }
`;
const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;
const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;
const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;
export const Frame = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  overflow: scroll;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: ${(p) => (p.scrollable ? "normal" : "center")};
  background-color: rgba(107, 102, 199);
  opacity: ${(p) => (p.opacity ? 0.85 : 1)};
  h3 {
    margin: 24px 0;
    cursor: pointer;
  }

  /* overflow-y: scroll; */
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
`;
export const ScalingContainer = styled.div`
  position: relative;
  height: 667px;
  min-height: 667px;
  width: 375px;
  padding: 30px;
  @media only screen and (max-height: 667px) {
    transform: ${(p) => `scale(${p.h / 667})`};
  }
`;

const btnRotate = keyframes`
  0% {
    transform: rotate(-45deg);
    animation-timing-function: cubic-bezier(0.23, 0.07, 0.08, 0.91);
  }
  33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.28, -0.06, 0.61, 0.89);
  }
  66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.32, -0.18, 0.66, 1);
  }
  100% {
    transform: rotate(0deg);
  }
`;
const btnRotateAnim = css`
  ${btnRotate} 500ms forwards
`;

const Back = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: #ffb000;
  cursor: pointer;
  svg {
    animation: ${btnRotateAnim};
  }
`;
const HeaderD = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  height: 40px;

  h1 {
    font-size: 26px;
  }
`;
export const Header = ({
  name,
  handleAbove,
  userSettings: { sound, volume },
}) => {
  const [goBackSfx] = useSound(goBack, { volume });
  return (
    <HeaderD>
      <h1>{name}</h1>
      <Back
        onClick={() => {
          if (sound) goBackSfx();
          handleAbove(false);
        }}
      >
        <BackSvg />
      </Back>
    </HeaderD>
  );
};
